<div class="row" [formGroup]="formGroup" *ngIf="formGroup.controls.parties?.length > 1 || forceDisplay">
  <div class="col-4">
    <div class="row ms-0 me-0" *ngFor="let party of formGroup.controls.parties?.controls; index as j;">
      <div class="row col-12" [formGroup]="party">
        <mat-form-field appearance="outline">
          <mat-label>{{party.get('name').value}} Ownership (0-100%)</mat-label>
          <input type="number" matInput placeholder="{{party.get('name').value}} Ownership (0-100%)" formControlName="ownership">
          <span class="d-flex align-items-center" matSuffix>% <mat-icon *ngIf="productCategory === 'secured-asset'" class="ms-2" matTooltip="To be eligible for a homeowner discount, the borrower must own their own home or an investment property.">info</mat-icon></span>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="col-12">
    <mat-error *ngIf="formGroup.controls.parties?.errors?.ownershipMax">
      Total ownership cannot be more than 100%
    </mat-error>
    <mat-error *ngIf="formGroup.controls.parties?.errors?.ownershipMin">
      Total ownership cannot be 0
    </mat-error>
    <mat-error *ngIf="formGroup.controls.parties?.errors?.ownership">
      You are about to enter an ownership of less than 100%, please confirm this is correct.
      <button mat-raised-button class="fmc-button-primary ms-2 mt-2" color="primary" (click)="confirmReducedOwnership(formGroup)">
        <mat-icon>done</mat-icon>
      </button>
    </mat-error>
  </div>
</div>
